import apiClient from '@shared/api/apiClient';

/**
 * GET /api/v1/approvals/guide
 * 전자결재 결재라인 기본 순서 및 회사별 가이드 정보를 조회합니다.
 * @returns {Promise<ApprovalGuideResponseDTO>}
 */
export const getApprovalGuide = async () => {
  const response = await apiClient.get('/v1/approvals/guide', { withAuth: true });
  return response.data.resultData;
};

/**
 * GET /api/v1/approvals/guide/{docTitle}
 * 특정 doc_title에 해당하는 결재라인 기본 순서 및 가이드 정보를 조회합니다.
 * @param {string} docTitle - 조회할 문서 양식의 그룹 제목
 * @returns {Promise<ApprovalGuideResponseDTO>}
 */
export const getApprovalGuideByDocTitle = async (docTitle) => {
  const encodedDocTitle = encodeURIComponent(docTitle);
  const response = await apiClient.get(`/v1/approvals/guide/${encodedDocTitle}`, {
    withAuth: true,
  });
  return response.data.resultData;
};

/**
 * PUT /api/v1/approvals/guide
 * 결재라인 가이드 정보를 업데이트합니다.
 * @param {Array<{idx: number, firstStepRequired: boolean, secondStepRequired: boolean, thirdStepRequired: boolean, agreementRequired: boolean, ceoRequired: boolean, sortOrder?: number}>} guides - 업데이트할 가이드 목록
 * @returns {Promise<ResponseDTO>}
 */
export const updateApprovalGuide = async (guides) => {
  const response = await apiClient.put(
    '/v1/approvals/guide',
    { guides },
    {
      withAuth: true,
    },
  );
  return response.data;
};
